import React from 'react';
import { Tabs, Tab, TabPanels, TabPanel, TabList } from '../../../../common/components/Tabs';
import { BlocDTab1 } from './BlocDTab1';
import { BlocDTab2 } from './BlocDTab2';

export const BlocDTabs = ({
  match: {
    params: { folderId, tabIndex },
  },
  blocId,
  ...props
}) => {
  return (
    <Tabs folderId={folderId} tabIndex={tabIndex} blocId={blocId}>
      <TabList>
        <Tab>Validation du 2DPE</Tab>
        <Tab>Préparation de la demande de devis</Tab>
      </TabList>
      <TabPanels>
        <TabPanel>
          <BlocDTab1 {...props} />
        </TabPanel>
        <TabPanel>
          <BlocDTab2 {...props} />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};
